import FileDownload from 'js-file-download';

import jsToCsv from './jsToCsv';

const gradesFields = ['firstName', 'lastName', 'email', 'externalId', 'grade'];

const downloadGradeCsv = ({ filename, grades }) => {
  const content = jsToCsv(gradesFields, grades);

  FileDownload(
    content,
    filename.endsWith('.csv') ? filename : `${filename}.csv`,
    'text/csv;charset=utf-8;'
  );
};

export default downloadGradeCsv;
